import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_zcq9sturtm: FaireBrandEntity = {
  token: "b_zcq9sturtm",
  type: "brand",
  name: "Comfy Cubs",
  avatarUrl:
    "https://cdn.faire.com/fastly/59120aed4a98a48274d99b998b13abcf54ea57dd38e4616ccb52ff3f6eb44d10.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/f1b9ffdecd9f9af4898bd052ee49efc48caefa90f96c37707afb400a6ed18dfc.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/59120aed4a98a48274d99b998b13abcf54ea57dd38e4616ccb52ff3f6eb44d10.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/f1b9ffdecd9f9af4898bd052ee49efc48caefa90f96c37707afb400a6ed18dfc.jpeg",
  location: "Miami, FL, USA",
  minimumOrderDollars: 100,
  rating: 4.9,
  reviewCount: 112,
  isTopShop: true,
  isInsider: true,
  description:
    "Comfy Cubs is the place to find the best everyday items for the nursery of your dreams. \n\nIt all started when two innovative and caring dads joined forces to bring nursery essentials to parents and caregivers with a line that’s kind to people, the planet, and your pocketbook! Today, we’re the go-to source for exceptional baby shower gifts and baby registry must-haves to keep babies safe and happy from day one.\n\nOur “dadpreneurer” founders are genuinely vested in child rearing, raising five kids between them, and ensuring that other young families can conveniently find beautifully made, affordable, and environmentally-friendly products. They get how important this is to everyday life. Must-haves such as burp cloths and swaddles help days go a little smoother, providing a smile to a little one's face and that of their hard-working parents. \n\nOur collection also includes blankets, crib sheets, changing pads, bibs, caddy, washcloths, pacifiers and clips, and even muslin blankets for moms. You’ll find trendy evergreen designs and classic prints made with premium, soft, durable materials (organic bamboo, muslin, and cotton) that are sustainable and gentle on baby’s skin. Extra care is taken in creating each piece.\n\nWe’re all about supporting families here at Comfy Cubs. Our top priority is to ensure that families enjoy every purchase and know that we’re a brand they can trust to make life easier, answering questions and offering solutions.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:46.735Z",
    importedBy: "entity-db-cli",
  },
};
